module.exports = __webpack_public_path__ + "img/damare01.2b980cfb.jpg";